import { render } from "./UnidadesPage.vue?vue&type=template&id=2fdb878b"
import script from "./UnidadesPage.vue?vue&type=script&lang=js"
export * from "./UnidadesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__